import { getShouldUseZendeskSandbox } from "@faire/help-center-utils/serialized-data/getShouldUseZendeskSandbox";
import {
  StrictLocalizeFunction,
  backwardsCompatibleValues,
} from "@faire/web--source/common/localization/localize";

export const TABLET_GUTTER_SIZE = 24;
export const DESKTOP_GUTTER_SIZE = 56;

export type SupportParams = {
  topicId?: string;
  categoryId?: string;
  articleId?: string;
};

export const isHiddenSection = (sectionId: number | undefined) => {
  if (!sectionId) {
    return false;
  }
  const BRAND_HIDDEN_SECTION_ID = getShouldUseZendeskSandbox()
    ? 14638005358107
    : 360009975811;
  const RETAILER_HIDDEN_SECTION_ID = getShouldUseZendeskSandbox()
    ? 14638190793371
    : 360012034032;
  return [BRAND_HIDDEN_SECTION_ID, RETAILER_HIDDEN_SECTION_ID].includes(
    sectionId
  );
};

export const READ_MORE = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "Read More",
    description: {
      text: "Default link in an article preview, goes to the full article",
    },
  });

export const BROWSE_ALL_TOPICS = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "Browse all topics",
    description: {
      text: "Title for a list containing all article topics",
    },
  });

export const viewAllText = (
  totalNumber: number,
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize(
    {
      defaultMessage: "View All ({totalNumber})",
      description: {
        text: "Button to display all elements from a list",
      },
    },
    backwardsCompatibleValues({ totalNumber })
  );
